import { SupportedLanguages } from '@/lang/lang-settings';
import { CoparticipationTranslations } from './models/coparticipation-translaction-model';
import { ptBR } from './translactions/pt-BR';
import { enUS } from './translactions/en-US';

// eslint-disable-next-line import/prefer-default-export
export const coparticipation: Record<SupportedLanguages, CoparticipationTranslations> = {
  'pt-BR': ptBR,
  'en-US': enUS,
};
